<template>
  <v-dialog
    v-model="confirmationModal"
    max-width="600"
  >
    <v-card>
      <v-card-title class="headline">Вы уверены, что хотите удалить {{deleteTargetTitle}}?</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="accent"
          flat="flat"
          @click="confirmationModal = false"
        >
          Нет
        </v-btn>

        <v-btn
          color="accent"
          flat="flat"
          @click="deleteDocument"
        >
          Да
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DocumentsDeleteConfirmationModal',
  data () {
    return {
      confirmationModal: false,
      item: null
    }
  },
  computed: {
    deleteTargetTitle () {
      return this.item && this.item.doc_title && this.item.doc_id ? `${this.item.doc_title} №${this.item.doc_id}` : ''
    }
  },
  methods: {
    open (item) {
      this.confirmationModal = true
      this.item = item
    },
    close () {
      this.confirmationModal = false
    },
    async deleteDocument () {
      await this.$emit('ok', this.item)
      this.confirmationModal = false
    }
  }
}
</script>

<style scoped>

</style>
